const buttons = [
  {
    label: "Undo Changes",
    icon: null,
    className: "btn btn-link",
    attributes: {
      type: "reset",
      "data-event-category": "Role Selector",
      "data-event-action": "Reset",
    },
  },
  {
    label: "Save",
    icon: null,
    attributes: {
      type: "submit",
      class: "btn btn-emphasized",
      "data-event-category": "Role Selector",
      "data-event-action": "Save",
    },
  },
];

export { buttons as default };
